<template>
  <div>
    <v-card
      v-for="(item, index) in itemList"
      v-bind:key="index"
      class="mx-auto mb-3 card-box main-card with-avatar"
      elevation="0"
    >
      <v-row class="ma-0">
        <v-row class="ma-0 card-header" justify="space-between">
          <v-col class="pa-0 text-center" cols="12">
            <v-avatar size="58" color="#f4f6f7">
              <icon-paid-holiday :width="24" :height="24" size="24" />
            </v-avatar>
          </v-col>
          <v-col cols="12" class="pa-0 text-center pt-4 desc"
            >잔여연차 <span class="point-blue cnt">{{ item.restCnt }}</span
            >일에 대해<br />
            휴가계획을 작성해주세요.</v-col
          >
        </v-row>
      </v-row>
      <v-card-actions class="pa-0 justify-center">
        <v-row align="center" justify="space-around" class="ma-0 btn-wrap">
          <v-btn
            class="v-btn"
            block
            elevation="0"
            color="#465166"
            @click="toPlanWriteView"
          >
            <span class="white--text">연차휴가 계획작성</span>
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
// 연차휴가계획작성
import { getPsnlHolidayList } from '@/api/main';
import dayjs from 'dayjs';
import IconPaidHoliday from '@/assets/customIcon/IconPaidHoliday.vue';
import routerNames from '@/const/routerConstants';
import { mapGetters, mapMutations } from 'vuex';

export default {
  components: {
    IconPaidHoliday,
  },
  data: () => ({
    itemList: [],
    commonCode: {
      14: '연차',
      100: '배우자출산휴가',
    },
    menu: {
      applCd: '22',
      bookmarkYn: 'Y',
      gntGubunCd: '1',
      gubun: 'vacations',
      menuNm: '연차휴가',
    },
  }),
  computed: {
    ...mapGetters(['GET_USER_DATA']),
  },
  methods: {
    ...mapMutations('ELA', ['SET_GNT_GUBUN_CD', 'SET_APP_MENU']),

    async fetchPsnlHolidayList(searchYear) {
      try {
        const response = await getPsnlHolidayList({ searchYear });
        const list = response.data.data;
        list.forEach(item => {
          item.gntName = this.commonCode[item.gntCd];
        });
        this.itemList = list;
      } catch (error) {
        console.log(error);
      }
    },

    async toPlanWriteView() {
      this.$router.push(routerNames.AnnualPlanWrite);
    },
  },
  created() {
    this.fetchPsnlHolidayList(dayjs().year().toString());
  },
};
</script>
